import type { LangCode } from "@/lib/gql/__generated__/graphql";

import type { ProductOptionI18nFormModel } from "../type";

type Props = {
	hotelID: string;
	optionID: string;
	lang: LangCode;
	queryData: ProductOptionI18nFormModel["QueryData"];
};

export const DEFAULT_PRODUCT_OPTION_I18N_INPUT_MODEL = ({ hotelID, optionID, lang }: Props) => {
	const inputModel: ProductOptionI18nFormModel["InputModel"] = {
		hotelID,
		optionID,
		lang,

		name: "",
		description: "",

		subOptions: [],
	} satisfies ProductOptionI18nFormModel["InputModel"];

	return inputModel;
};
